var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart34-template',{attrs:{"board-ids":[114, 234, 235, 236, 237],"data-type":_vm.dataType,"field-code":"facility-public","graph-id":71,"title":"(공중(다중)이용시설) 관리 현황","unit":"건","orientation":_vm.orientation}})
}
var staticRenderFns = []

export { render, staticRenderFns }